module.exports = __webpack_public_path__ + "static/img/sactionmenban2.3ea36c1c.png";